module.exports = __webpack_public_path__ + "img/stopTalking.46eb032f.png";